module.exports = "/images/logo-in-square-beta.svg?89898c27f885285fafcc601603c5ac39";